export const getCnpjResumido = () =>
  localStorage.getItem('cliente_cnpj_resumido');

export const getRazaoSocial = () =>
  localStorage.getItem('cliente_razao_social');

export const getCnpjSecundarios = () =>
  JSON.parse(localStorage.getItem('cliente_secundarios')).map(
    cliente => cliente.cnpj_resumido
  );

export const getIdUsuario = () => localStorage.getItem('idUsuario');
